// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import fetch from './utils/fetch'
import Blob from '@/excel/Blob'
import proportion from 'vue-proportion-directive'
// import echarts from 'echarts'

// Vue.prototype.$echarts = echarts
const { export_json_to_excel } = require('@/excel/Export2Excel');
Vue.use(proportion)
Vue.prototype.$Blob = Blob
Vue.prototype.$export_json_to_excel = export_json_to_excel

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.prototype.$fetch = fetch



/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})
var instance = axios.create({
    baseURL: '',
    timeout: 5000,
    headers: { 'Content-Type': 'multipart/form-data' }
})

Vue.prototype.axios = axios
Vue.prototype.instance = instance


let x = window.location.href
    // 如果token存在就说明是从A系统跳转过来的
    if (x) {
        // 取“=”之后的token
        let y = x.indexOf('=')
        let z = x.substring(y + 1)
        // 把token存进B系统
        const parts = z.split('&');

        // 提取 Token 和 Username
        const token = parts[0]; // 获取 token 部分
        const username = parts[1].split('=')[1]; // 获取 username 部分，并从 "username=sgz" 中提取 "sgz"
        localStorage.setItem('token', token)
        localStorage.setItem("username", username);
        localStorage.setItem("serviceKey", "80");
    }else{
        this.$message.error('错误！')
    }



// WEBPACK FOOTER //
// ./src/main.js